import { render, staticRenderFns } from "./TokenRouterView.vue?vue&type=template&id=1901d23e&scoped=true&"
import script from "./TokenRouterView.vue?vue&type=script&lang=js&"
export * from "./TokenRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1901d23e",
  null
  
)

export default component.exports